/**
 * Null Provider
 *
 * Passthrough provider that does no noise suppression.
 * Used when noise suppression is disabled.
 */

import { NoiseSuppressionProvider } from './NoiseSuppressionProvider.js';

export class NullProvider extends NoiseSuppressionProvider {
  constructor() {
    super('none');
    this.initialized = true; // Always ready
  }

  /**
   * Always supported
   */
  static isSupported() {
    return true;
  }

  /**
   * No initialization needed
   */
  async initialize() {
    this.initialized = true;
  }

  /**
   * Pass through audio unchanged
   */
  process(samples, sampleRate) {
    return samples;
  }

  /**
   * No cleanup needed
   */
  async destroy() {
    this.initialized = false;
  }
}

export default NullProvider;
